
import { Component, Mixins } from "vue-property-decorator";
import { ICheckable } from "../../../../../domain/document/items";

@Component({
})
export default class CheckDrawableMixin extends Mixins() {
  readPropertyOrDefault: <T>(reader: (source: ICheckable) => T, defaultValue: T) => T;
  writePropertyWhenValid: (writer: (source: ICheckable) => void) => void;

  get isChecked(): boolean {
    return this.readPropertyOrDefault(s => s.isChecked, false);
  }

  set isChecked(value: boolean) {
    this.writePropertyWhenValid(s => s.isChecked = value);
  }
}
